import {
  statusKey,
  statusWithDateKey,
} from '@lmt/unicorn-shared/app/components/patients/profile/cases/components/documents/common';
import {
  CHANNEL_LABEL,
  ChannelKey,
} from '@lmt/unicorn-shared/app/components/patients/profile/cases/types';
import React, { useMemo } from 'react';
import { FileInfoDto, TransportChannelStatusDto } from '@lmt/shared-types';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { getFormattedDateTime } from '@lmt/unicorn-shared/app/components/patients/common';
import styles from './DocumentTransportTooltip.module.scss';

type Props = { file: FileInfoDto };

export const DocumentTransportTooltip: React.FC<Props> = ({ file }) => {
  const i18n = useScopedTranslation('patients.documents.delivery_status');

  const rows = useMemo(() => {
    const t = file.transportInfo;
    const list: Array<{
      channel: ChannelKey;
      data: TransportChannelStatusDto;
    }> = [];
    if (t?.hL7 && (t.hL7.status != null || t.hL7.date))
      list.push({ channel: 'hl7', data: t.hL7 });
    if (t?.gdt && (t.gdt.status != null || t.gdt.date))
      list.push({ channel: 'gdt', data: t.gdt });
    if (t?.email && (t.email.status != null || t.email.date))
      list.push({ channel: 'email', data: t.email });

    return list.map(({ channel, data }) => {
      const currentStatusKey = statusKey(data.status, data.errorMessage);
      const currentStatusKeyWithDate = statusWithDateKey(
        data.status,
        data.errorMessage,
      );
      const when = data.date ? getFormattedDateTime(data.date) : null;
      const prefix =
        currentStatusKey === 'in_process'
          ? i18n.t('sending', { channel: CHANNEL_LABEL[channel] })
          : i18n.t('sent', { channel: CHANNEL_LABEL[channel] });

      const meta =
        when && currentStatusKeyWithDate
          ? i18n.t(currentStatusKeyWithDate, { when })
          : i18n.t(currentStatusKey);

      return { id: channel, prefix, meta };
    });
  }, [file.transportInfo]);

  if (rows.length === 0) return null;

  return (
    <div className={styles.tooltip}>
      {rows.map((r) => (
        <div className={styles.row}>
          <span className={styles.prefix}>{r.prefix}</span>
          <span className={styles.gap}> </span>
          <span className={styles.meta}>{r.meta}</span>
        </div>
      ))}
    </div>
  );
};
